import React from 'react';
import styled from 'App/styled';

import { AboutUs as AboutUsType } from 'store/footer/types';
import { contentTypes, isToRenderContent } from '../helper';


const Wrapper = styled.div`

  h2 {
    ${({ theme }) => theme.typography.titleXSmall};
    color: ${props => props.theme.footerLinks};
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    margin: 0 0 10px;
    color: ${props => props.theme.footerLinks};
    ${({ theme }) => theme.typography.bodyMedium};
  }

  a {
    color: ${props => props.theme.footerLinks};
    text-decoration: none;
  }
`;

interface Props {
  aboutUs: AboutUsType;
  pageType: string;
}

const AboutUs = ({ aboutUs, pageType } : Props) => {
  if (!(isToRenderContent(pageType, contentTypes.PriceList))) {
    return null;
  }
  return (
    <Wrapper>
      <div dangerouslySetInnerHTML={{ __html: aboutUs?.brandInfo }} />
    </Wrapper>
  );
};


export default AboutUs;
